module.exports = __webpack_public_path__ + "img/logo.5333f963.webp";